// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"dab16646","368":"1faa514c","420":"a2d75704","562":"5319c262","715":"9d014594","729":"f93f4daf","842":"8c24699e","910":"f696742b"}[chunkId] + ".chunk.js";
};